"use strict";

require("../../style/default.less");

require("./index.less");

require("../../tabs/style");

require("../../row/style");

require("../../col/style");